module.exports = __webpack_public_path__ + "media/new-point-sound.8f4d9e17.mp3";